import React, {Component} from 'react';

class SIntroduce extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: 'introduce',
		}
	}

	changeTab = (id) => {
		this.setState({
			activeTab: id
		})
	}

	render() {
		const record = this.props.record;
		if(Object.keys(record).length == 0) return '';
		return (
			<div className="mt-px-40">
				<div className="d-flex align-items-center mb-3">
					<button
						className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'introduce' ? 'active' : '')}
						onClick={() => this.changeTab('introduce')}>소개
					</button>
					<button
						className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'education' ? 'active' : '')}
						onClick={() => this.changeTab('education')}>학력
					</button>
					<button
						className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'career' ? 'active' : '')}
						onClick={() => this.changeTab('career')}>경력
					</button>
				</div>
				<div>
					<div className={"tab-data " + (this.state.activeTab === 'introduce' ? 'active' : '')}>
						<div className="pt-4 pb-4 border-top border-bottom border-lightgray">
							<div className="font-size-14 color-lightblack"
							     dangerouslySetInnerHTML={{ __html: record.introduction ? record.introduction.replace(/(?:\r\n|\r|\n)/g, '<br />') : '입력된 정보가 없습니다.' }}>
							</div>
						</div>
					</div>
					<div className={"tab-data " + (this.state.activeTab === 'education' ? 'active' : '')}>
						<div className="pt-4 pb-4 border-top border-bottom border-lightgray">
							<div className="font-size-14 color-lightblack"
								 dangerouslySetInnerHTML={{ __html: record.education ? record.education.replace(/(?:\r\n|\r|\n)/g, '<br />') : '입력된 정보가 없습니다.' }}>
							</div>
						</div>
					</div>
					<div className={"tab-data " + (this.state.activeTab === 'career' ? 'active' : '')}>
						<div className="pt-4 pb-4 border-top border-bottom border-lightgray">
							<div className="font-size-14 color-lightblack"
								 dangerouslySetInnerHTML={{ __html: record.career ? record.career.replace(/(?:\r\n|\r|\n)/g, '<br />') : '입력된 정보가 없습니다.' }}>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
};

export default SIntroduce;
